module.exports = __webpack_public_path__ + "img/dataAssetOrange.002b980d.png";